import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingHeaderHighlightProductRoot = styled("section")<{}>(() => {
  return css`
    background: radial-gradient(
      89.73% 46.53% at 64.69% 55.84%,
      #38557b 0%,
      #162740 100%
    );

    @media ${responsiveMap.mobile} {
      margin-top: -64px;
      padding-top: 64px;
    }
  `;
});
